<script setup lang="ts">
import CommunityPublicInformation from "@/components/CommunityPublicInformation.vue";
import HomeNothingSelected from "@/components/HomeNothingSelected.vue";

import {useCommunityDataPublic} from '@/stores/communityDataPublic'
import {computed} from "vue";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const communityDataPublicStore = useCommunityDataPublic()
const communityPublic = computed(()=> communityDataPublicStore.communityActive);
// const multiDsoMode = computed(()=> communityPublic.value?.communityType === '16b');

</script>

<template>
  <v-container class="containerBase">

    <v-container class="containerStandard">
      <p v-if="communityPublic" class="textDescriptor">{{communityPublic?.name}}</p>

      <p class="textHeadline">{{ t('welcomeToJoin') }}</p>

      <p class="textDescriptor">
        {{ t('welcomeToEnergyCommunity') }}
      </p>

      <div class="textDescriptor" v-if="communityPublic !== null">
        {{ t('preparationInfo') }}
        <ul>
          <li>
            <b>{{ t('preparationItems.energyBills1') }}</b>
            {{ t('preparationItems.energyBills2') }}
          </li>
          <li>
            {{ t('preparationItems.bankInfo1') }}
            <b>{{ t('preparationItems.bankInfo2') }}</b>
          </li>
          <li>
            {{ t('preparationItems.companyInfo1') }}
            <b>{{ t('preparationItems.companyInfo2') }}</b>
            {{ t('preparationItems.companyInfo3') }}
            <ul>
              <li>
                {{ t('preparationItems.companyInfoSub') }}
              </li>
            </ul>
          </li>
          <li>
            {{ t('preparationItems.generatorInfo') }}
            <ul>
              <li>
                {{ t('preparationItems.generatorInfoSub1') }}
              </li>
              <li>
                {{ t('preparationItems.generatorInfoSub2') }}
              </li>
            </ul>
            {{ t('preparationItems.generatorInfoPost') }}
          </li>
        </ul>
      </div>

      <v-divider class="divider"></v-divider>
    </v-container>

    <CommunityPublicInformation v-if="communityPublic !== null" :community-public="communityPublic"/>
    <HomeNothingSelected v-if="communityPublic === null" />


  </v-container>
</template>

